import { ChangeLanguage } from '@components/langSelector/lang-selector';

const SessionData = () => {
    return (
     

  
        <ChangeLanguage />
  
   
    );
};
export default SessionData;
